import axios from 'axios'

const instance = axios.create({
    baseURL: process.env.VUE_APP_WEB_API ?? 'http://localhost:3010',
    headers: {
        'Content-Type': 'application/json',
    },
})

export default instance